
<div class="l-main" role="main">
	<div class="l-container">

		<div class="l-content">


			<div class="panel-pane bg-transparent align-center">
				<ul class="list--pipe">
					<li><a href="">Visit the UC Davis directory</a></li>
				</ul>
			</div>

			<div class="panel-pane box">
        
          
<!-- ********** Main content ********** -->
						<div id="main_section" role="main">

							<!-- Center column (primary content) -->

							<div id="center_column">

								<div id="center_column_inner_wrap">


   <div class="container">
   <div class="row">
   
   <div *ngIf="departments?.length > 100">
   		<p class="alert">
			<em>Search returned more than 100 results. </em> Please refine your search if you would like more specific results.
		</p>
   </div>

   <table class="table">
   
   <thead class="thead-inverse">
<!--   
   <tr>
   
   </tr>
   -->
   
   </thead>
   <tbody>
   
   

   <ng-container *ngFor="let department of departments; let i= index">
      
   <tr *ngIf="i >= 1">
     
   <ng-container *ngIf="department.seeAlsoOID !==null  ">
        <td style="width: 75%" colspan="4" align="left">
           <app-spaces [count] = "department?.indent"></app-spaces>
	       <a routerLink="/deptDetailSearch/{{department.seeAlsoOID}}">
           {{department.directoryName}}</a>
        </td>
        <td style="width: 15%" align="left">{{department.phoneNumber}}</td>
   </ng-container>   
   

   <ng-container *ngIf="department.type === 'url'; then caseA; else caseB">
   </ng-container>

   <ng-template #caseA>

   <ng-container *ngIf="department.seeAlsoOID ===null  ">
         <td style="width: 75%" colspan="4" align="left">
           <app-spaces [count] = "department?.indent"></app-spaces>
           <a href="http://{{department.directoryName}}">
             {{department.directoryName}}
           </a>
         </td>	
	 <td style="width: 15%" align="left">{{department.phoneNumber}}</td>
   </ng-container>

   </ng-template>

     
   <ng-template #caseB>

     <ng-container *ngIf="department.type === 'email'; then caseC; else caseD">
     </ng-container>

     <ng-template #caseC>
        <ng-container *ngIf="department.seeAlsoOID ===null  ">   
          <td style="width: 75%" colspan="4" align="left">
            <app-spaces [count] = "department?.indent"></app-spaces>
             <a href="mailto:{{department.directoryName}}">
              {{department.directoryName}}
             </a>
          </td>
	      <td style="width: 15%" align="left">{{department.phoneNumber}}</td>
        </ng-container>
     </ng-template>

     <ng-template #caseD>     
        <ng-container *ngIf="department.seeAlsoOID ===null  ">   
          <td style="width: 75%" colspan="4" align="left">
            <app-spaces [count] = "department?.indent"></app-spaces>
              {{department.directoryName}}
          </td>
	      <td style="width: 15%" align="left">{{department.phoneNumber}}</td>
        </ng-container>
     </ng-template>

   </ng-template>
     
   </tr>
      
   <tr style="background-color: #BCC5CF" *ngIf="i < 1">
      	<td style="width: 75%" colspan="4" align="left"><b>{{department.directoryName}}</b>&nbsp;
      	<a href="https://org.ucdavis.edu/odr">Problem with the listing?</a>
      	</td>
	  	<td style="width: 15%" align="left"><b>{{department.phoneNumber}}</b></td>
   </tr>

   </ng-container>


   
   </tbody>
   </table>
   </div>
   </div>
   
   						</div>

						<!-- ********** End main content ********** -->
													</div>

							<!-- End center column -->

						</div>
						
		<!--end .l-content-->
		</div>
		
	</div>

</div>
<!--End role=main-->
</div>



<p class="privacy">
	<strong>Privacy Notice:</strong> This campus directory is the property
	of <a href="https://www.ucdavis.edu"><font size="3" color="navy">University
			of California, Davis.</font> </a> To protect the privacy of individuals listed
	herein, in accordance with the State of California Information
	Practices Act, this directory may not be used, rented, distributed, or
	sold for commercial purposes.
</p>